module.exports = __webpack_public_path__ + "static/media/blinds-open.c51cdc90.svg";